














import Component from "vue-class-component";
import { Mixins, Watch } from "vue-property-decorator";
import { ChartOverlayConfigItemMixin } from "./chart-overlay-config-item.mixin";
import { ChartOverlayMetadata } from "../../../../../shared/types/layout-workspace/components/chart-overlay/chart-overlay-metadata.interface";
import { get } from "lodash";
import { UPDATE_CHART_OVERLAY } from "../../../../store/chart-overlay.module/mutations/update-chart-overlay.mutation";

@Component({
  components: {
    PureSlider: () => import("../../pure-config/PureSlider.vue"),
  },
})
export default class OverlayWidthConfig extends Mixins(
  ChartOverlayConfigItemMixin,
) {
  private width = 0;

  // mounted() {  }
  private operationWidth(method: string) {
    const metadata: ChartOverlayMetadata = this.getOverlayMetadataById(
      this.activeOverlayId,
    );
    if (metadata) {
      const width = get(metadata, this.setting.path);
      if (this.setting.commitUnit) {
        if (method === "set") {
          this.width = parseInt(width) || this.width;
        } else {
          return parseInt(width) || this.width;
        }
      } else {
        if (method === "set") {
          this.width = width || this.width;
        } else {
          return width || this.width;
        }
      }
    }
  }

  @Watch("activeOverlayId", { immediate: true })
  async onSelectedOverlayChange() {
    this.operationWidth("set");
  }

  @Watch("sizeInStore", { deep: true })
  Setting() {
    this.operationWidth("set");
  }

  get sizeInStore() {
    return this.operationWidth("get");
  }

  updateLineWidth(width: number) {
    const { commitUnit } = this.setting;
    this.$stock.commit(UPDATE_CHART_OVERLAY, {
      id: this.activeOverlayId,
      path: this.setting.path,
      value: commitUnit ? width + commitUnit : width,
    });
  }
}
